import React, { useState } from "react";
import styled from "styled-components";
import arrow from "../assets/arrow-down.svg";
import { motion } from "framer-motion";

function Page6Pc() {
  const [opened, setOpened] = useState([false, false, false, false]);
  const variants1 = {
    visible: {
      height: "fit-content",
    },
    hidden: {
      height: 0,
    },
  };
  return (
    <MainContainer id="faq">
      <Title>FAQ</Title>
      <Contents>
        <Line />
        <Row
          onClick={() => {
            setOpened((prev) => {
              const newArr = [...prev];
              newArr[0] = !newArr[0];
              return newArr;
            });
          }}
        >
          <TextsContainer>
            <Q>Q.</Q>
            <Text>단가는 얼마나 나올까요?</Text>
          </TextsContainer>
          <Arrow deg={opened[0] ? "180" : "0"} src={arrow} />
        </Row>
        <Animated
          variants={variants1}
          initial="hidden"
          animate={opened[0] ? "visible" : "hidden"}
          transition={{ duration: 0.3 }}
        >
          <Line />
          <AnswerRow>
            <TextsContainer>
              <Q>A.</Q>
              <Text>
                주얼리는 무게, 크기, 디자인 이렇게 3가지를 통해 단가가 결정되기
                때문에 상담을 통해 안내드리겠습니다.
              </Text>
            </TextsContainer>
          </AnswerRow>
        </Animated>
        <Line />
        <Row
          onClick={() => {
            setOpened((prev) => {
              const newArr = [...prev];
              newArr[1] = !newArr[1];
              return newArr;
            });
          }}
        >
          <TextsContainer>
            <Q>Q.</Q>
            <Text>본 작업은 얼마나 소요되나요?</Text>
          </TextsContainer>
          <Arrow deg={opened[1] ? "180" : "0"} src={arrow} />
        </Row>
        <Animated
          variants={variants1}
          initial="hidden"
          animate={opened[1] ? "visible" : "hidden"}
          transition={{ duration: 0.3 }}
        >
          <Line />
          <AnswerRow>
            <TextsContainer>
              <Q>A.</Q>
              <Text>
                디자인 확정 후 발주 지시 주시면 공장 상황에 따라 2주정도
                소요됩니다.
              </Text>
            </TextsContainer>
          </AnswerRow>
        </Animated>
        <Line />
        <Row
          onClick={() => {
            setOpened((prev) => {
              const newArr = [...prev];
              newArr[2] = !newArr[2];
              return newArr;
            });
          }}
        >
          <TextsContainer>
            <Q>Q.</Q>
            <Text>최소 수량이 있나요?</Text>
          </TextsContainer>
          <Arrow deg={opened[2] ? "180" : "0"} src={arrow} />
        </Row>
        <Animated
          variants={variants1}
          initial="hidden"
          animate={opened[2] ? "visible" : "hidden"}
          transition={{ duration: 0.3 }}
        >
          <Line />
          <AnswerRow>
            <TextsContainer>
              <Q>A.</Q>
              <Text>
                오피셜 수량은 200개입니다. 하지만 디자인 수량 및 스큐에 따라
                조정 가능합니다.
              </Text>
            </TextsContainer>
          </AnswerRow>
        </Animated>
        <Line />
        <Row
          onClick={() => {
            setOpened((prev) => {
              const newArr = [...prev];
              newArr[3] = !newArr[3];
              return newArr;
            });
          }}
        >
          <TextsContainer>
            <Q>Q.</Q>
            <Text>불량 제품이 발견되면 A/S가 가능한가요?</Text>
          </TextsContainer>
          <Arrow deg={opened[3] ? "180" : "0"} src={arrow} />
        </Row>
        <Animated
          variants={variants1}
          initial="hidden"
          animate={opened[3] ? "visible" : "hidden"}
          transition={{ duration: 0.3 }}
        >
          <Line />
          <AnswerRow>
            <TextsContainer>
              <Q>A.</Q>
              <Text>
                가능합니다. 새 제품으로 교환해드리거나 발주수량에서 2~5개를 추가
                여유분으로 드리고 있습니다.
              </Text>
            </TextsContainer>
          </AnswerRow>
        </Animated>
        <Line />
        <Row
          onClick={() => {
            setOpened((prev) => {
              const newArr = [...prev];
              newArr[4] = !newArr[4];
              return newArr;
            });
          }}
        >
          <TextsContainer>
            <Q>Q.</Q>
            <Text>디자인 의뢰도 가능한가요?</Text>
          </TextsContainer>
          <Arrow deg={opened[4] ? "180" : "0"} src={arrow} />
        </Row>
        <Animated
          variants={variants1}
          initial="hidden"
          animate={opened[4] ? "visible" : "hidden"}
          transition={{ duration: 0.3 }}
        >
          <Line />
          <AnswerRow>
            <TextsContainer>
              <Q>A.</Q>
              <Text>
                가능합니다. 룩북 촬영에 쓰일 컬렉션 주얼리도 가능합니다. 자세한
                내용은 상담을 통해 안내드리겠습니다.
              </Text>
            </TextsContainer>
          </AnswerRow>
        </Animated>
        <Line />
        <Row style={{ height: "200px" }}></Row>
      </Contents>
    </MainContainer>
  );
}

export default Page6Pc;
const MainContainer = styled.div`
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #070707;
  z-index: 1;
  overflow: hidden;
  position: relative;
`;
const Title = styled.p`
  color: #fff;
  font-family: Pretendard;
  font-size: 50px;
  font-style: normal;
  font-weight: 700;
  line-height: 60px; /* 120% */
  margin-top: 150px;
`;
const Contents = styled.div`
  width: 80vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 70px;
  margin-bottom: 50px;
`;
const Line = styled.div`
  width: 100%;
  height: 1px;
  background: #47464d;
  z-index: 1;
`;
const Row = styled.div`
  cursor: pointer;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  z-index: 1;
  background: #070707;
`;
const TextsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 40px;
  margin-left: 40px;
  margin-top: 30px;
  margin-bottom: 30px;
  z-index: 1;
`;
const Q = styled.p`
  color: #fff;
  font-family: Pretendard;
  font-size: 34px;
  font-style: normal;
  font-weight: 600;
  line-height: 44px; /* 129.412% */
  z-index: 1;
`;
const Text = styled.p`
  max-width: 60vw;
  color: #fff;
  font-family: Pretendard;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 60px; /* 250% */
  word-break: keep-all;
  z-index: 1;
`;
const Arrow = styled.img`
  width: 50px;
  height: 50px;
  margin-right: 40px;
  transform: ${(props) => `rotate(${props.deg}deg)`};
  transition: 0.3s ease;
  z-index: 1;
`;
const AnswerRow = styled(Row)`
  background: #1c212d;
  z-index: 0;
`;
const Animated = styled(motion.div)`
  width: 100%;
  z-index: 0;
`;
